
import { installPie } from './pie/install'
import { installLine } from './line/install'
import { installBar } from './bar/install'
import { installLineBar } from './line-bar/install'
import { installBarX } from './bar-x/install'

export function inistallReportEcharts() {
  try {
    return [
      ...installPie(),
      ...installLine(),
      ...installBar(),
      ...installLineBar(),
      ...installBarX(),
    ]
  } catch (e) {
    return []
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/index.js